import { withRouter } from "react-router-dom";

import { Dispatch } from "common/types/redux";

import { getMySubscriptionTierName } from "seneca-common/features/subscriptions/features/subscription-products/selectors/subscriptionSubscriptionProduct";
import { getSubscriptionTierName } from "seneca-common/features/subscriptions/features/subscription-products/state";
import {
  getIsUpgrading,
  getUpgradeSubscriptionProductId,
  subscriptionPaymentFailed,
  subscriptionPaymentRequiresAuthentication
} from "seneca-common/features/subscriptions/state";
import {
  compose,
  connect
} from "seneca-common/utils/components/container-utils";

import {
  handleAuthentication,
  withStripeElements
} from "features/subscriptions/features/stripe";
import { getTierNameHeader } from "features/subscriptions/helpers";

import { DispatchProps, MergedProps, OwnProps, StateProps } from "./types";

type State = any;

const mapStateToProps = (
  state: State,
  { stripe, subscriptionId }: OwnProps
): StateProps => {
  const paymentRequiresAuthentication =
    subscriptionPaymentRequiresAuthentication(state, subscriptionId);

  const commonProps = {
    paymentFailed: subscriptionPaymentFailed(state, subscriptionId),
    paymentRequiresAuthentication,
    buttonDisabled: paymentRequiresAuthentication && !stripe
  };

  if (getIsUpgrading(state, subscriptionId)) {
    const upgradeSubscriptionProductId = getUpgradeSubscriptionProductId(
      state,
      subscriptionId
    );
    const tierName = getSubscriptionTierName(
      state,
      upgradeSubscriptionProductId
    );

    return {
      ...commonProps,
      upgrading: !!upgradeSubscriptionProductId,
      packageName: getTierNameHeader(tierName)
    };
  } else {
    const tierName = getMySubscriptionTierName(state, subscriptionId);
    return {
      ...commonProps,
      upgrading: false,
      packageName: getTierNameHeader(tierName)
    };
  }
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  {
    stripe,
    history,
    linkToRetrySubscriptionPayment,
    linkToRetryUpgradePayment,
    linkToAddCoursesPage,
    subscriptionId
  }: OwnProps
): DispatchProps => {
  const retryPayment = () =>
    history.push(linkToRetrySubscriptionPayment(subscriptionId));

  const retryUpgradePayment = () =>
    history.push(linkToRetryUpgradePayment(subscriptionId));

  const onSuccess = () => history.push(linkToAddCoursesPage);

  const authenticate = (upgrading: any) => {
    dispatch(
      handleAuthentication({
        subscriptionId,
        stripe: stripe as any,
        onSuccess,
        onRetryPaymentRequired: upgrading ? retryUpgradePayment : retryPayment
      })
    );
  };

  return {
    retryPayment,
    retryUpgradePayment,
    authenticate
  };
};

const mergeProps = (
  props: StateProps,
  { retryPayment, retryUpgradePayment, authenticate }: DispatchProps,
  ownProps: OwnProps
): MergedProps => {
  const retryPaymentAction = props.upgrading
    ? retryUpgradePayment
    : retryPayment;
  const onButtonClick = props.paymentFailed
    ? retryPaymentAction
    : props.paymentRequiresAuthentication
      ? () => authenticate(props.upgrading)
      : null;
  return { ...ownProps, ...props, onButtonClick };
};

const SubscriptionRequiresAction = compose(
  withRouter,
  // @ts-ignore
  withStripeElements,
  // @ts-ignore
  connect(mapStateToProps, mapDispatchToProps, mergeProps)
);

export { SubscriptionRequiresAction };
